<template>
  <div class="vx-col w-full">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="ค้นหาข้อมูล Active User">
          <label>เริ่มต้น: </label>
          <flat-pickr :config="configdateTimePicker" v-model="before_datetime" placeholder="Date Time" />
          <br>
          <br>
          <label> สิ้นสุด: </label>
          <flat-pickr :config="configdateTimePicker" v-model="after_datetime" placeholder="Date Time" />
          <br>
          <br>
          <div class="flex flex-wrap items-center">
            <vs-button class="ml-2" color="success"
              @click="selectdate_time({ label: 'เว็บไซต์ทั้งหมด', value: 'all' })">ค้นหา</vs-button>

            <div class="ml-auto flex items-center mt-2 sm:mt-0">
              <span class="mr-2 text-sm">รูปแบบการแสดงผล:</span>
              <vs-button
                size="small"
                icon-pack="feather"
                icon="icon-grid"
                :color="viewMode === 'card' ? 'primary' : 'dark'"
                :type="viewMode === 'card' ? 'filled' : 'border'"
                class="mr-1"
                @click="setViewMode('card')"
              >การ์ด</vs-button>
              <vs-button
                size="small"
                icon-pack="feather"
                icon="icon-list"
                :color="viewMode === 'table' ? 'primary' : 'dark'"
                :type="viewMode === 'table' ? 'filled' : 'border'"
                @click="setViewMode('table')"
              >ตาราง</vs-button>
            </div>
          </div>
        </vx-card>

      </div>


    </div>
    <br>
    <div v-if="viewMode === 'card'" class="vx-row">
      <ActiveUserCard v-for="(game, index) in games" :key="index" :statistic="game.count" :statisticTitle="`${game.code.toUpperCase()} (${game.name})`" :icon="game.icon" :data="game.data" :beforeDate="before_datetime" :afterDate="after_datetime" />
    </div>

    <vx-card v-else title="Active User (Table)">
      <vs-table search stripe :data="games">
        <template slot="thead">
          <vs-th sort-key="code">เกม</vs-th>
          <vs-th sort-key="count">จำนวน Active User</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(tr, i) in data" :key="i" :data="tr">
            <vs-td>
              <feather-icon v-if="tr.icon" :icon="tr.icon" svgClasses="h-4 w-4 mr-2 inline-block align-middle" />
              {{ tr.code ? tr.code.toUpperCase() : '' }} ({{ tr.name }})
            </vs-td>
            <vs-td>{{ tr.count }}</vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-download"
                :disabled="!tr.data || tr.data.length === 0"
                @click="openExport(tr)"
              >Export</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-prompt
      :title="exportTarget ? `Export: ${exportTarget.code ? exportTarget.code.toUpperCase() : ''} (${exportTarget.name})` : ''"
      class="export-options"
      @cancle="clearFields"
      @accept="confirmExport"
      accept-text="Export"
      @close="clearFields"
      :active.sync="exportPromptActive"
    >
      <vs-input v-model="exportFileName" placeholder="Enter File Name.." class="w-full" /><br>
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from '../../axios'
import vSelect from 'vue-select'
import moment from 'moment'
import ActiveUserCard from '@/components/ActiveUserCard.vue'

export default {
  data () {
    return {
      currentDataSource: '',
      before_datetime: moment.tz('Asia/Bangkok').format('YYYY-MM-DD 00:00'),
      after_datetime: moment.tz('Asia/Bangkok').add(1, 'days').format('YYYY-MM-DD 00:00'),
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      fileName: '',
      headerTitle: ['Username', 'เบอร์โทรศัพท์', 'LINE'],
      headerVal: ['topup_username', 'member_phone', 'member_line'],
      headerVal1: ['username', 'member_phone', 'member_line'],
      headerVal2: ['username', 'member_phone', 'member_line'],
      headerVal3: ['username', 'member_phone', 'member_line'],
      headerVal4: ['username', 'member_phone', 'member_line'],
      headerVal5: ['username', 'member_phone', 'member_line'],
      headerVal6: ['username', 'member_phone', 'member_line'],
      headerVal7: ['username', 'member_phone', 'member_line'],
      headerVal8: ['username', 'member_phone', 'member_line'],
      headerVal9: ['username', 'member_phone', 'member_line'],
      headerVal10: ['username', 'member_phone', 'member_line'],
      headerVal11: ['username', 'member_phone', 'member_line'],
      headerVal12: ['username', 'member_phone', 'member_line'],
      headerVal13: ['username', 'member_phone', 'member_line'],
      headerVal14: ['username', 'member_phone', 'member_line'],
      headerVal15: ['username', 'member_phone', 'member_line'],
      headerVal16: ['username', 'member_phone', 'member_line'],
      headerVal17: ['username', 'member_phone', 'member_line'],
      headerVal18: ['username', 'member_phone', 'member_line'],
      headerVal19: ['username', 'member_phone', 'member_line'],
      headerVal20: ['username', 'member_phone', 'member_line'],
      headerVal21: ['username', 'member_phone', 'member_line'],
      headerVal22: ['username', 'member_phone', 'member_line'],
      headerVal23: ['username', 'member_phone', 'member_line'],
      activeuser:
      {
        count: {},
        excel: {}
      },
      countuser: {
        topup: ''
      },
      data: [],
      formats: ['xlsx', 'csv', 'txt'],
      selectedFormat: 'xlsx',
      cellAutoWidth: true,
      games: [],
      currentWebsite: { label: 'เว็บไซต์ทั้งหมด', value: 'all' },
      viewMode: 'card',
      viewModeStorageKey: 'reportActiveUserViewMode',
      exportPromptActive: false,
      exportTarget: null,
      exportFileName: ''
    }
  },
  components: {
    flatPickr,
    vSelect,
    ActiveUserCard
  },
  async mounted () {
    this.loadViewMode()
    this.selectdate_time({ label: 'เว็บไซต์ทั้งหมด', value: 'all' })
  },
  methods: {
    async selectdate_time (from_website) {
      // Extract data from from_website
      const { label, value } = from_website

      try {
        const response = await axios.get(`reportactiveuser2/activeuser/${this.before_datetime}/${this.after_datetime}/${value}`)
        // Convert response data into games array
        this.games = response.data
      } catch (error) {
        console.error('Error fetching active user data:', error)
      }

      // await axios
      //   .get(`reportactiveuser2/dataactiveuser/${this.before_datetime}/${this.after_datetime}/${value}`)
      //   .then(response => (this.activeuser.excel = response.data))
      // this.fileName = `Report_Activeuser ${this.before_datetime} ${this.after_datetime} (${label})`

      this.currentDataSource = label
    },
    exportToExcel (count_data, name, headerVal) {
      import('@/vendor/Export2Excel').then(excel => {
        const list = count_data
        const data = this.formatJson(headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })

        // Log the export action
        this.logExportAction(count_data, name)

        this.clearFields()
      })
    },
    async logExportAction (count_data, name) {
      try {
        const objectLogs = {
          username: null,
          category: 'exportReport',
          type: 'activeUserReport',
          amount: count_data.length || 0,
          info: `ดาวโหลด report active user: ${name}`,
          admin: this.$store.state.AppActiveUser.admin_user,
          data: {
            before_datetime: this.before_datetime,
            after_datetime: this.after_datetime,
            filename: this.fileName,
            format: this.selectedFormat,
            record_count: count_data.length || 0,
            game_name: name
          }
        }
        
        await axios.post('/agent/log', objectLogs)
      } catch (error) {
        console.error('Failed to log export action:', error)
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    activatePrompt (index) {
      this[`activePrompt${index}`] = true
    },
    loadViewMode () {
      try {
        const saved = localStorage.getItem(this.viewModeStorageKey)
        if (saved === 'card' || saved === 'table') {
          this.viewMode = saved
        }
      } catch (e) {
        // ignore (e.g. SSR, privacy mode)
      }
    },
    setViewMode (mode) {
      if (mode !== 'card' && mode !== 'table') return
      this.viewMode = mode
      try {
        localStorage.setItem(this.viewModeStorageKey, mode)
      } catch (e) {
        // ignore
      }
    },
    openExport (game) {
      if (!game || !game.data || game.data.length === 0) return
      this.exportTarget = game
      this.exportFileName = `Report_Activeuser ${this.before_datetime} ${this.after_datetime} (${game.code ? game.code.toUpperCase() : ''}_${game.name})`
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
      this.exportPromptActive = true
    },
    async confirmExport () {
      const game = this.exportTarget
      if (!game) return
      const fileName = this.exportFileName
      const target = game
      await import('@/vendor/Export2Excel').then(excel => {
        const list = target.data || []
        const data = this.formatJson(this.headerVal1, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.logExportAction(list, `${target.code ? target.code.toUpperCase() : ''} (${target.name})`)
      })
      this.exportTarget = null
      this.exportFileName = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
}

</script>

<style></style>
